module.exports = __webpack_public_path__ + "static/media/avaneq-statue-small.c23e52c8.png";